import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Field, reduxForm, change } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import cowTransparent from "../../../../shared/img/cow-transparent.gif";
import { formValidators } from '../../../../util/index';
import {connect} from "react-redux";

const minLength8 = formValidators.minLength(8);

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
      if((prevProps.usernameSaved !== this.props.usernameSaved) && this.props.usernameSaved) {
          this.props.changeFieldValue('email', this.props.usernameSaved)
      }
  }

    showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  renderField = ({ input, placeholder, type, meta: { touched, error, warning } }) => (
      <div style={{width: '100%'}}>
        <input style={{backgroundColor: 'white'}} {...input} placeholder={placeholder} type={type}/>
        <div className="input-error-container">
          {touched && ((error && <span className="error-message">{this.props.t(`errors.${error}`)}</span>) || (warning && <span className="error-message">{warning}</span>))}
        </div>
      </div>
  );

  render() {
    const { handleSubmit, toggleForgotPassword, t } = this.props;
    const { showPassword } = this.state;

    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('login.email')}</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="email"
              component={this.renderField}
              validate={[ formValidators.validateRequired, formValidators.validateEmail ]}
              normalize={(value) => value.toLowerCase()}
              type="text"
              placeholder={t('login.email')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('login.password')}</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="password"
              component={this.renderField}
              validate={[formValidators.validateRequired, minLength8]}
              type={showPassword ? 'text' : 'password'}
              placeholder={t('login.password')}
            />
            <button
              type="button"
              className={`form__form-group-button${showPassword ? ' active' : ''}`}
              onClick={e => this.showPassword(e)}
            ><EyeIcon />
            </button>
          </div>
          <div className="account__forgot-password">
            <span onClick={toggleForgotPassword}>{t('login.forgotPassword')}</span>
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field
              name="remember_me"
              component={renderCheckBoxField}
              label={t('login.rememberMe')}
            />
          </div>
        </div>
        <div className="error-container">
          {
            this.props.loginError &&
            <span className="error-message">{t(`errors.session.${this.props.loginErrorMessage}`)}</span>
          }
        </div>
        <div className="account__btns">
          <Button className="btn btn-primary account__btn cow__btn" type="submit" disabled={this.props.loginPending}>
              {
                  this.props.loginPending ?
                      <img className="cow__loader button_loader" alt="cow" src={cowTransparent}/> :
                      <span>{t('login.login')}</span>
              }
          </Button>
         <Link className="btn btn-outline-primary account__btn" to="/register">{t('login.register')}</Link>
        </div>
      </form>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change('log_in_form', field, value))
});

export default connect(null, mapDispatchToProps)(withTranslation('common')(reduxForm({
  form: 'log_in_form', // a unique identifier for this form
})(LogInForm)));
